// extracted by mini-css-extract-plugin
module.exports = {"header":"AppBar_header__K1T0z"};